import { gql } from '@apollo/client';

import { useQueryWithLog } from '@lib/hooks/logging-hooks';
import { getLogger } from '@lib/logging';

type Acknowledgement = {
  source: string;
  type: string;
  version: string;
};

type CanopyTermsOfAgreementsResponse = {
  canopyTermsOfServiceAgreements: {
    success: boolean;
    acknowledgements: Acknowledgement[];
  };
};

const logger = getLogger('use-canopy-terms');

export const CURRENT_CANOPY_TOS_VERSION = '1';
export const TERMS_OF_SERVICE_SOURCE = 'MY_NERDWALLET';

export const GET_CANOPY_TERMS_OF_SERVICE_AGREEMENTS = gql`
  query GetCanopyTermsOfServiceAgreements {
    canopyTermsOfServiceAgreements {
      success
      acknowledgements {
        source
        type
        version
      }
    }
  }
`;

export const useCanopyTermsQuery = () => {
  const { data, loading, error } =
    useQueryWithLog<CanopyTermsOfAgreementsResponse>(
      logger,
      GET_CANOPY_TERMS_OF_SERVICE_AGREEMENTS,
    );

  const hasAcceptedCanopyTerms =
    data?.canopyTermsOfServiceAgreements?.acknowledgements?.some(
      (ack) => ack.version === CURRENT_CANOPY_TOS_VERSION,
    );

  return {
    hasAcceptedCanopyTerms,
    loading,
    error,
  };
};
